import { Component, ChangeDetectorRef, OnDestroy, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { TopBarService } from '../top-bar.service';
import { StorageService } from 'libs/base/src/lib/services/storage.service';
@Component({
    selector: 'ubi-cell-top-bar-refresh-rate',
    templateUrl: './top-bar-refresh-rate.component.html',
    styleUrls: ['./top-bar-refresh-rate.component.scss'],
    standalone: false
})
export class TopBarRefreshRateComponent implements OnInit, OnDestroy {
  @Input() currentView: string = '';
  applicableRefreshRateOpt: any = [];
  displayAutoIcon = false;
  refreshRateOpt: any = [ 
    { refresh_rate_key: 'now', refresh_rate_value: 'now', isAutoRefresh: false, isSelectedRefreshRate: false},
    { refresh_rate_key: 'off', refresh_rate_value: 'off', isAutoRefresh: false, isSelectedRefreshRate: true},
    { refresh_rate_key: 15000, refresh_rate_value: '15s', isAutoRefresh: true, isSelectedRefreshRate: false},
    { refresh_rate_key: 30000, refresh_rate_value: '30s', isAutoRefresh: true, isSelectedRefreshRate: false},
    { refresh_rate_key: 60000, refresh_rate_value: '1m', isAutoRefresh: true, isSelectedRefreshRate: false},
    { refresh_rate_key: 300000, refresh_rate_value: '5m', isAutoRefresh: true, isSelectedRefreshRate: false}
  ];
  largeDatasetThreshold = 50000;
  refreshRateOptSubscriber: Subscription;
  disableRefreshRate: boolean = true;
  showRefreshRate: boolean = true;
  totalNodeCount = 0;
  triggerRefreshSubscription: Subscription;
  constructor(private cdr: ChangeDetectorRef, private topBarService: TopBarService, private _storageService: StorageService) { }

  ngOnInit(): void {
    this.getTotalCount();
    this.triggerRefreshSubscription = this.topBarService.triggerRefresh.subscribe((value) => {
      if(value){
        this.choseRespectiveRefreshRate('now');
      }
    })
  }

  getTotalCount(){
    this.refreshRateOptSubscriber = this.topBarService?.getTotalCountValue$.subscribe((element) => {
      if(element || element == 0){
        this.totalNodeCount = element
        this.checkCustomerHaveLargeDataset(element);
      }
    });
  }

  checkCustomerHaveLargeDataset(datasetSize){
    if (datasetSize >= this.largeDatasetThreshold){
      this.applicableRefreshRateOpt = this.refreshRateOpt.filter(option => 
        !(option.refresh_rate_key === 15000 || option.refresh_rate_key === 30000)
      );
    }else{
      this.applicableRefreshRateOpt = this.refreshRateOpt;
    }
    this.cdr.detectChanges();
    this.setRefreshRate();
  }

  setRefreshRate(){
    let refreshRateOpt = this._storageService.getItem('refresh-rate-pref') ? JSON.parse(this._storageService.getItem('refresh-rate-pref')) : {};
    let selectedRefreshRate = (refreshRateOpt && refreshRateOpt[this.currentView]) ? refreshRateOpt[this.currentView] : 'off';
    this.topBarService.setRespectiveRefreshRateSubject.next(selectedRefreshRate)
    this.updateRefreshRateIcon(selectedRefreshRate);
    this.markSelectedRefreshRateOpt(selectedRefreshRate);
  }

  markSelectedRefreshRateOpt(selectedRefreshRate){
    let markOffAsSelected = false;
    this.applicableRefreshRateOpt.forEach(element => {
      if(element.refresh_rate_key == selectedRefreshRate && element.refresh_rate_key !== 'now'){
        element['isSelectedRefreshRate'] = true;
      } else if(element.refresh_rate_key == selectedRefreshRate && element.refresh_rate_key == 'now'){
        markOffAsSelected = true;
      } else {
        element['isSelectedRefreshRate'] = false;
      }
    });

    
    if(markOffAsSelected){
      this.choseRespectiveRefreshRate('off');
      markOffAsSelected = false;
    }

    this.disableRefreshRate = false;
    this.cdr.detectChanges();    
  }

  updateRefreshRateIcon(selectedRefreshRate){
    if(selectedRefreshRate){
      this.displayAutoIcon = !(selectedRefreshRate == 'now' || selectedRefreshRate == 'off') ? true : false;
    }
  }


  choseRespectiveRefreshRate(selectedRefreshRate){
    let refreshRateOpt:{} = this._storageService.getItem('refresh-rate-pref') ? JSON.parse(this._storageService.getItem('refresh-rate-pref')) : {};
    refreshRateOpt[this.currentView] = selectedRefreshRate;
    this._storageService.store('refresh-rate-pref', refreshRateOpt)
    this.topBarService.setRespectiveRefreshRateSubject.next(selectedRefreshRate);
    this.updateRefreshRateIcon(selectedRefreshRate);
    this.markSelectedRefreshRateOpt(selectedRefreshRate);
    if(selectedRefreshRate == 'now'){
      this.disableRefreshRateBtn();
    }
  }

  disableRefreshRateBtn(){
    this.disableRefreshRate = true;
    let timeInterval= (this.totalNodeCount >= this.largeDatasetThreshold) ? 10000 : 5000;
    setTimeout(()=> {
      this.disableRefreshRate = false;
    }, timeInterval)
  }

  ngOnDestroy() {
    if(this.refreshRateOptSubscriber){
      this.refreshRateOptSubscriber.unsubscribe()
    }
    if(this.triggerRefreshSubscription)
      this.triggerRefreshSubscription.unsubscribe();
  }
}
